import React from 'react';
import { Stepper } from '@innovationnorway/cl-react';

import { Intro } from './Intro';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';

type Props = {
  onClose: () => void;
};

const CreateMemberForm: React.FC<Props> = ({ onClose }) => {
  const [currentStep, setCurrentStep] = React.useState(1);

  const goNextStep = () => setCurrentStep((step) => Math.min(step + 1, 4));
  const goPreviousStep = () => setCurrentStep((step) => Math.max(step - 1, 1));

  return (
    <div>
      <Stepper orientation="horizontal" data-size="sm" className="margin-top--2">
        {[1, 2, 3, 4].map((step) => (
          <Stepper.Step key={step} state={step === currentStep ? 'active' : 'idle'} interactive={false}>
            {''}
          </Stepper.Step> // HACK: Stepper.Step requires children
        ))}
      </Stepper>
      {currentStep === 1 && <Intro goNextStep={goNextStep} />}
      {currentStep === 2 && <Step1 goNextStep={goNextStep} goPreviousStep={goPreviousStep} />}
      {currentStep === 3 && <Step2 goNextStep={goNextStep} goPreviousStep={goPreviousStep} />}
      {currentStep === 4 && <Step3 goPreviousStep={goPreviousStep} onClose={onClose} />}
    </div>
  );
};

export default CreateMemberForm;
